//
// Copyright (c) 2011-2024 by Curalate, Inc
//

import { theme } from '@bvengineering/unison-core';
import React from 'react';
import styled from 'styled-components';

import Button from '@components/atoms/button/Button';
import {
  IButtonStateStyles,
  OverlayButtonStyles,
} from '@components/atoms/button/buttonStyles';

const triggerStyles: IButtonStateStyles = {
  ...OverlayButtonStyles,
  fixed: {
    fontWeight: 'normal',
    borderShape: 'circle',
    borderThickness: 'thin',
  },
  standard: {
    color: theme.colors.black,
    backgroundColor: theme.colors.gray1,
    borderColor: theme.colors.gray1,
  },
  hover: {
    color: theme.colors.white,
    backgroundColor: theme.colors.blue2,
    borderColor: theme.colors.blue2,
  },
  active: {
    color: theme.colors.white,
    backgroundColor: theme.colors.blue2,
    borderColor: theme.colors.blue2,
  },
  isInlineWithText: true,
};

export interface ContentDrawerTriggerProps {
  className?: string;
  onClick?: () => void;
}

export const ContentDrawerTrigger = ({
  className,
  onClick,
}: ContentDrawerTriggerProps) => {
  return (
    <ContentDrawerButton
      className={className}
      buttonStyles={triggerStyles}
      iconName='new'
      type='button'
      onClick={onClick}
    />
  );
};

const ContentDrawerButton = styled(Button)(
  ({ theme }) => `
    min-width: ${theme.spacings[4]};
    width: ${theme.spacings[4]};
  `,
);
